import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CommonModule } from '@angular/common';
import { NavService } from '../../../services/nav.service';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordUserComponent } from './changepassword/passuser.component';
import { NewCaseService } from '../../../services/newcase.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, CommonModule, FormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit {
  date = new Date();
  search: string = ''

  constructor(
    public auth: AuthService,
    public nav: NavService,
    public router: Router,
    private modalService: NgbModal,
    private newService: NewCaseService
  ) { }

  ngOnInit(): void {

  }

  public Open() {
    const modalRef = this.modalService.open(ChangePasswordUserComponent);
  }

  public Search(key: any) {
    if (key.code === 'Enter' || key.code == 'NumpadEnter') {
      if (this.search) {
        this.newService.searchReport(this.search);
        this.router.navigateByUrl("/search/" + this.search);
        this.search = ''
      }
    }
  }

}
